import { useState } from 'react';
import { useSchemaOrg, educationalOrganizationSchema, localBusinessSchema } from '../../utils/seo';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Business from './components/Business';
import Blog from './components/Blog';
import Testimonials from './components/Testimonials';
import Recruit from './components/Recruit';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Schema.org JSON-LD
  useSchemaOrg({
    type: 'EducationalOrganization',
    data: educationalOrganizationSchema,
  });

  useSchemaOrg({
    type: 'LocalBusiness',
    data: localBusinessSchema,
  });

  return (
    <>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <main>
        <Hero />
        <About />
        <Business />
        <Blog />
        <Testimonials />
        <Recruit />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
